import { render, staticRenderFns } from "./SupportDropDown.vue?vue&type=template&id=f2e42ffe"
import script from "./SupportDropDown.vue?vue&type=script&lang=js"
export * from "./SupportDropDown.vue?vue&type=script&lang=js"
import style0 from "./SupportDropDown.vue?vue&type=style&index=0&id=f2e42ffe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports